function ShimmerBar({ className = '' }: { className?: string }) {
  return (
    <div
      className={`rounded-md overflow-hidden ${className}`}
      style={{ backgroundColor: 'rgba(26, 58, 92, 0.15)' }}
    >
      <div
        className="h-full w-full animate-shimmer"
        style={{
          background:
            'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.3) 50%, transparent 100%)',
          backgroundSize: '200% 100%'
        }}
      />
    </div>
  );
}

function SkeletonRankCard({ isWide = false }: { isWide?: boolean }) {
  return (
    <div
      className="flex items-center rounded-xl px-3 py-2 gap-2"
      style={{
        backgroundColor: '#E6F4FF',
        border: '2px solid rgba(0,0,0,0.1)'
      }}
    >
      <ShimmerBar className={`shrink-0 ${isWide ? 'w-8 h-5' : 'w-6 h-4'}`} />
      <ShimmerBar className="flex-1 h-4" />
      <ShimmerBar className={`shrink-0 ${isWide ? 'w-14 h-5' : 'w-10 h-4'}`} />
    </div>
  );
}

function SkeletonPill() {
  return (
    <div
      className="flex flex-col items-center justify-center rounded-2xl px-2 py-1.5 flex-1 gap-1"
      style={{
        backgroundColor: '#E6F4FF',
        border: '2px solid rgba(0,0,0,0.1)'
      }}
    >
      <ShimmerBar className="w-14 h-2.5" />
      <ShimmerBar className="w-8 h-3" />
    </div>
  );
}

function SkeletonTabButton() {
  return (
    <div
      className="flex-1 h-12 rounded-xl flex items-center justify-center"
      style={{
        backgroundColor: 'rgba(59, 130, 246, 0.15)',
        border: '2px solid rgba(0,0,0,0.1)'
      }}
    >
      <ShimmerBar className="w-20 h-4" />
    </div>
  );
}

function SkeletonGradientCard({ colorStart, colorEnd }: { colorStart: string; colorEnd: string }) {
  return (
    <div
      className="flex items-center rounded-xl px-3 py-2 gap-2"
      style={{
        background: `linear-gradient(to right, ${colorStart}, ${colorEnd})`,
        border: '2px solid rgba(0,0,0,0.15)',
        opacity: 0.6
      }}
    >
      <ShimmerBar className="shrink-0 w-6 h-4" />
      <ShimmerBar className="flex-1 h-4" />
      <ShimmerBar className="shrink-0 w-10 h-4" />
    </div>
  );
}

export function LeaderboardSkeleton() {
  return (
    <div className="flex flex-col gap-3">
      {/* User summary skeleton */}
      <div className="flex flex-col gap-2">
        <SkeletonRankCard isWide />
        <div className="flex gap-2">
          <SkeletonPill />
          <SkeletonPill />
          <SkeletonPill />
        </div>
      </div>

      {/* Tab nav skeleton */}
      <div className="flex gap-2">
        <SkeletonTabButton />
        <SkeletonTabButton />
      </div>

      {/* Leaderboard list skeleton */}
      <div className="flex flex-col gap-2">
        <SkeletonGradientCard colorStart="#E6B800" colorEnd="#FAD05B" />
        <SkeletonGradientCard colorStart="#9D9D9D" colorEnd="#FFFFFF" />
        <SkeletonGradientCard colorStart="#947636" colorEnd="#CCAA72" />
        {Array.from({ length: 4 }).map((_, i) => (
          <SkeletonRankCard key={i} />
        ))}
      </div>
    </div>
  );
}

export default LeaderboardSkeleton;
